<div class="modal-agency">
  <div class="modal-agency__wrapper">

    <button
      type="button"
      class="modal-agency__close"
      aria-label="Close"
      (click)="closeModal()"
    >
      <i class="icon-close"></i>
    </button>

    <div class="modal-agency__header">
      <h2>Scegli agenzia</h2>
      <p *ngIf="!previouslySelectedStore">
        Scegli a quale agenzia desideri affidare la tua pratica.
      </p>

      <div class="warn-wrap" *ngIf="showWarningMessage">
        <i class="g-icon-info-rounded"></i>
        <p>Per poter proseguire è necessario selezionare un'agenzia.</p>
      </div>

      <p *ngIf="previouslySelectedStore">
        Agenzia selezionata:
        <strong>{{ previouslySelectedStore?.denomination }}</strong>
        {{ previouslySelectedStore?.address }} -
        {{ previouslySelectedStore?.city }} ({{
          previouslySelectedStore?.province
        }}).
        <span class="booking-flow__fake-link" (click)="activeModal.dismiss()"
          >Conferma questa agenzia</span
        >
        oppure scegline un'altra fra quelle disponibili.
      </p>
    </div>

    <div class="modal-agency__body">
      <div class="map__wrapper" style="width: 100%; height: 500px">
        <div class="map__element" id="map" style="height: 100%"></div>
      </div>

      <div class="search" (submit)="onNewLocationSearch()">
        <form class="search__form" #locationSearchForm="ngForm">
          <input
            class="search__input form-control"
            type="text"
            [(ngModel)]="userSearchInput"
            #locationSearchInput="ngModel"
            name="locationSearchInput"
            placeholder="Cerca un indirizzo"
          />
          <button class="search__button btn btn--light-blue" type="submit">
            Cerca
          </button>
        </form>

        <div class="search__status">
          <p class="search__no-results" *ngIf="unknownAddress">
            Indirizzo non riconosciuto.
          </p>
        </div>
      </div>

      <div class="agency agency--slider">
        <h3 class="agency__heading" *ngIf="nearStores?.length === 1">
          1 agenzia presente in questa zona
        </h3>

        <h3 class="agency__heading" *ngIf="nearStores?.length > 1">
          Sono presenti {{ nearStores?.length }} agenzie in questa zona
        </h3>

        <swiper
          [config]="config"
          [(index)]="index"
          class=""
          *ngIf="nearStores?.length"
        >
          <div class="agency__card" *ngFor="let nearStore of nearStores">
            <h3 class="agency__name">{{ nearStore.denomination }}</h3>
            <div class="agency__address">
              <i class="icon-pin"></i>
              {{ nearStore.address }} - {{ nearStore.city }} ({{
                nearStore.province
              }})
            </div>
            <div
              class="agency__navigate booking-flow__fake-link"
              (click)="showStoreOnMap(nearStore)"
            >
              vedi sulla mappa
            </div>
            <button
            class="agency__select btn btn--brand-color-03"
            (click)="selectStore(nearStore.id)"
            >
            Scegli questa agenzia
          </button>
          </div>
        </swiper>
        <div class="agency-select-swiper-button-next"></div>
        <div class="agency-select-swiper-button-prev"></div>
      </div>
    </div>

    <div class="agency agency__no-results" *ngIf="!nearStores?.length">
      <h3 class="agency__heading">Non sono presenti agenzie in questa zona</h3>
      <p>
        Nell'area visualizzata non è presente nessuna agenzia; prova ad
        allargare la mappa o a cercare un nuovo indirizzo. Oppure,
        <span class="booking-flow__fake-link" (click)="fitViewToMarkers()"
          >clicca qui</span
        >
        per visualizzare tutte le agenzie presenti sul territorio.
      </p>
    </div>
  </div>
</div>
